module.exports = {
  en: require("./src/en"),
}
